export default {
  changelog: {
    loading: "Loading…",
    title: "Version history",
    subtitle: "Here you can see all the improvements and new features we've added to the app.",
    current: "Current",
    initialVersion: "Initial version of the app.",
  },
};
